import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";

const ComboSideMenu = ({
  open,
  onClose,
  items,
  onRemove,
  onCheckout,
  comboType,
}) => {
  const [position, setPosition] = useState({ top: 120, right: 20 });
  const [dragging, setDragging] = useState(false);

  const onMouseDown = () => {
    if (window.innerWidth <= 1024) return;
    setDragging(true);
  };

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!dragging) return;

      setPosition({
        top: Math.max(80, e.clientY - 20),
        right: Math.max(10, window.innerWidth - e.clientX - 160),
      });
    };

    const onMouseUp = () => setDragging(false);

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [dragging]);

  const [minQuantity, setMinQuantity] = useState(0);
  const [discountPerItem, setDiscountPerItem] = useState(0);
  const [bulkCombos, setBulkCombos] = useState([]);
  const [bulkFinalPrice, setBulkFinalPrice] = useState(0);

  useEffect(() => {
    if (comboType !== "MIXED") return;

    const fetchComboOffer = async () => {
      try {
        const res = await fetch(getApiUrl("combo-active"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        const data = await res.json();
        if (data.success && data.data.length > 0) {
          const combo = data.data[0];
          setMinQuantity(combo.minQuantity);
          setDiscountPerItem(combo.discountPerItem);
        }
      } catch (err) {
        console.error("Combo fetch failed", err);
      }
    };

    fetchComboOffer();
  }, [comboType]);

  useEffect(() => {
    if (comboType !== "BULK") return;

    const fetchBulkCombos = async () => {
      try {
        const res = await fetch(getApiUrl("bulk-list"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        const data = await res.json();
        if (data.success) setBulkCombos(data.data);
      } catch (err) {
        console.error("Bulk combo fetch failed", err);
      }
    };

    fetchBulkCombos();
  }, [comboType]);

  // Ensure each item has qty
  const itemsWithQty = items.map((i) => ({ qty: 1, ...i }));

  const totalPrice = itemsWithQty.reduce(
    (sum, item) => sum + item.price * (item.qty || 1),
    0
  );

  const totalDiscount =
    comboType === "MIXED" && itemsWithQty.length >= minQuantity
      ? discountPerItem * itemsWithQty.length
      : 0;

  const finalPrice = totalPrice - totalDiscount;

  useEffect(() => {
    if (comboType !== "BULK") return;

    if (itemsWithQty.length === 0 || bulkCombos.length === 0) {
      setBulkFinalPrice(0);
      return;
    }

    const qty = itemsWithQty.reduce((sum, i) => sum + (i.qty || 1), 0);
    const subcategoryId = itemsWithQty[0].subcategoryId;

    const combo = bulkCombos.find(
      (c) =>
        (c.subcategoryId?._id || c.subcategoryId)?.toString() ===
        subcategoryId?.toString()
    );

    if (!combo) {
      setBulkFinalPrice(0);
      return;
    }

    const slab = combo.priceSlabs.find(
      (s) => qty >= s.minQuantity && (!s.maxQuantity || qty <= s.maxQuantity)
    );

    setBulkFinalPrice(slab ? slab.price : 0);
  }, [itemsWithQty, bulkCombos, comboType]);

  // const canCheckout =
  //   comboType === "MIXED"
  //     ? itemsWithQty.length >= minQuantity
  //     : itemsWithQty.length > 0;
  const canCheckout = itemsWithQty.length > 0;


  const priceToShow = comboType === "BULK" ? bulkFinalPrice : finalPrice;

  return (
    <div
      className={`combo-side ${open ? "open" : ""}`}
      style={{ top: position.top, right: position.right }}
    >
      <div className="combo-header drag-handle" onMouseDown={onMouseDown}>
        <h5>{comboType === "BULK" ? "Bulk Selection" : "Selected Combo"}</h5>
        <button onClick={onClose}>✖</button>
      </div>

      <div className="combo-body">
        {itemsWithQty.length === 0 ? (
          <p className="text-muted">No products selected</p>
        ) : (
          <>
            {itemsWithQty.map((item, index) => (
              <div key={item.id} className="combo-item">
                <div>
                  <strong>{item.name}</strong>
                  <div className="combo-row">
                    <span className="size-pill">{item.size}</span>
                    <span className="price">₹{item.price}</span>
                  </div>
                  {/* Qty input */}
                  <div className="combo-row mt-1">
                    Qty:{" "}
                    <input
                      type="number"
                      min="1"
                      value={item.qty}
                      onChange={(e) => {
                        const newItems = [...itemsWithQty];
                        newItems[index].qty = Number(e.target.value);
                        onRemove && onRemove(newItems);
                      }}
                      style={{ width: "50px", marginLeft: "5px" }}
                    />
                  </div>
                </div>
                <button onClick={() => onRemove(item.id)}>🗑</button>
              </div>
            ))}

            <hr />
            <p>Total: ₹{totalPrice}</p>
            {comboType === "MIXED" && totalDiscount > 0 && (
              <p className="text-success">Discount: -₹{totalDiscount}</p>
            )}
            <h6>Final: ₹{priceToShow}</h6>
          </>
        )}
      </div>

      <div className="combo-footer">
        <button
          className="btn btn-success w-100"
          disabled={!canCheckout}
          onClick={() =>
            onCheckout({
              items: itemsWithQty, 
              totalPrice,
              totalDiscount: comboType === "BULK" ? 0 : totalDiscount,
              finalPrice: priceToShow,
              comboType,
            })
          }
        >
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
};

export default ComboSideMenu;
